// Varaint number select component
import { MultiSelect, Anchor } from '@mantine/core'

// UI
import ImageWithFallbacks from '@/components/ui/ImageWithFallbacks'

// Classnames
import classNames from 'classnames'

// Dayjs
import dayjs from 'dayjs'

const StatusSelect = ({ value, onChange }) => {
    const data = ['ARCHIVED', 'ACTIVE', 'DRAFT']

    return (
        <MultiSelect
            value={value}
            label="Statut"
            placeholder="Sélectionnez un statut"
            onChange={onChange}
            data={data}
        />
    )
}

const CellTitle = ({ value, item }) => {
    return (
        <div className="table-cell p-5">
            <div className="flex gap-5 w-full">
                <div className="w-[100px]">
                    <ImageWithFallbacks
                        images={[item.image_url]}
                        width={100}
                        className="w-20 h-20 object-contain"
                    />
                </div>

                <div className="flex flex-col w-full">
                    <div className="flex gap-4 items-center">
                        <Anchor
                            href={`/products/shopify/${item.id}`}
                        >
                            {value}
                        </Anchor>
                    </div>

                    {item.status === 'ACTIVE' && !item.product && (
                        <span className="text-red-500">
                            Non associé à un produit du catalogue
                        </span>
                    )}

                    <div>
                        {item.shopify_product_variants.map((variant) => {
                            // Get all dispatch dates
                            const components_dispatch_dates =
                                variant.components_pivot?.map(
                                    (pivot) => pivot.component.dispatch_date
                                ) ?? []

                            // Get maximum dispatch date with reduce by comparing YYYY-MM-DD strings and avoiding null values
                            const max_dispatch_date =
                                components_dispatch_dates
                                    .filter((d) => d)
                                    .reduce((a, b) => (a > b ? a : b), null) ??
                                null

                            const can_be_sold =
                                variant.quantity_available > 0 ||
                                variant.inventory_policy === 'CONTINUE'

                            let dispatch_status = can_be_sold
                                ? 'immediate'
                                : 'not_sold'

                            if (can_be_sold && max_dispatch_date) {
                                const today = new Date()

                                const dispatch_date_obj = new Date(
                                    max_dispatch_date
                                )

                                if (dispatch_date_obj > today) {
                                    dispatch_status = 'preorder'
                                }
                            }

                            const classes = classNames(
                                'grid grid-cols-[1fr_400px] gap-2',
                                {
                                    'text-green-500':
                                        dispatch_status === 'immediate',
                                    'text-orange-500':
                                        dispatch_status === 'preorder',
                                    'text-red-500':
                                        dispatch_status === 'not_sold',
                                }
                            )

                            const verbose_dispatch_status = {
                                immediate: 'Expédition immédiate',
                                preorder:
                                    'Exp au ' +
                                    dayjs(max_dispatch_date).format('ll'),
                                not_sold: 'Non disponible',
                            }

                            const wcd_filled =
                                variant.wcd_jewels &&
                                variant.wcd_power &&
                                variant.wcd_strap &&
                                variant.wcd_case

                            return (
                                <div className={classes} key={variant.id}>
                                    <span className="grid grid-cols-[1fr_1fr] gap-2 items-center">
                                        <span>{variant.title}e</span>

                                        {!wcd_filled && (
                                            <span className="text-gray-400">
                                                Sans WCD
                                            </span>
                                        )}
                                    </span>

                                    <div className="grid grid-cols-[50px_100px_200px] gap-5 ml-auto">
                                        <span>
                                            {variant.quantity_available}
                                        </span>

                                        <span>{variant.inventory_policy}</span>

                                        <span>
                                            {
                                                verbose_dispatch_status[
                                                    dispatch_status
                                                ]
                                            }
                                        </span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <pre className="hidden">
                        <code>{JSON.stringify(item, null, 2)}</code>
                    </pre>
                </div>
            </div>
        </div>
    )
}

// Components
import Breadcrumbs from '@/components/ui/Breadcrumbs'
import ShopifyVariantsTable from '@/components/shopify/variants/ShopifyVariantsTable'

export default function ShopifyProductsIndex() {
    // Breadcrumbs
    const breadcrumbs = [
        {
            label: 'Produits Shopify',
        },
    ]

    return (
        <div>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <ShopifyVariantsTable />
        </div>
    )
}
